import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { scan } from 'rxjs/operators';

@Injectable()
export class SharedStateProvider {
  constructor() { }
  private paramSource = new BehaviorSubject(0);
  public incrementWaitingRequestsNr = new BehaviorSubject<number>(0);
  public waitingRequestsNr = this.incrementWaitingRequestsNr.pipe(
    scan((previous, increment) => previous + increment)
  );

  public setWaitingRequestNr(waitingRequestsNr: number) { this.incrementWaitingRequestsNr.next(waitingRequestsNr) }
  public decreaseWaitingRequestNr() { this.incrementWaitingRequestsNr.next(-1); }

  private selectedCaseIdSource = new BehaviorSubject<string | null>(null);
  public selectedCaseId = this.selectedCaseIdSource.asObservable();

  public setSelectedCaseId(caseId: string | null) {
    this.selectedCaseIdSource.next(caseId);
  }
}
